import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    dialogContentRoot: {
        overflowX: 'hidden',
        padding: '12px 26px 0 !important',
    },
    header: {
        '& h2': {
            color: '#092b4b',
            display: 'flex',
            alignItems: 'center'
        }
    },
    headerIcon: {
        marginRight: '10px',
        color: '#006eb5'
    },
    headerText: {
        fontWeight: 700,
        fontSize: '1.5rem',
        letterSpacing: '-0.015em',
        color: '#092b4b'
    }
}))

export default useStyles